import {
  ArrowRight,
  BadgeCheck,
  Building2,
  FileSearch,
  Globe2,
  Languages,
  Layers3,
  LockKeyhole,
  Scale,
  ScanSearch,
  ShieldCheck,
  Sparkles,
  Users2,
  Waypoints,
  Workflow,
} from "lucide-react";

export const homeIconMap = {
  arrow: ArrowRight,
  badge: BadgeCheck,
  building: Building2,
  filing: FileSearch,
  globe: Globe2,
  languages: Languages,
  layers: Layers3,
  lock: LockKeyhole,
  scale: Scale,
  scan: ScanSearch,
  shield: ShieldCheck,
  sparkles: Sparkles,
  users: Users2,
  waypoints: Waypoints,
  workflow: Workflow,
};

export function resolveHomeIcon(iconKey) {
  return homeIconMap[iconKey] || Layers3;
}
